import { Component, OnInit } from '@angular/core';
import { ConfirmationWorkPlaceService } from './confirmation-work-place.service';
import { numericalInputOnly } from '../../../utils/input-handler/numerical-input-only';
export class ConfirmationWorkPlaceComponent implements OnInit {
public data: any;
public numericalInputOnly: any = numericalInputOnly;
/**
 * @param {?} service
 */
constructor(public service: ConfirmationWorkPlaceService) {
    this.service.dataStore.subscribe(res => {
      this.data = res;
    });
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.service.getRegions({}, 'province');
    this.service.initData();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'confirmation-work-place',
  template: `
    <div class="tnk-card">
      <div class="tnk-card__header">
        <h1>Data Tempat Kerja</h1>
        <div>
          <small>Langkah 1 dari 4</small>
        </div>
      </div>
      <div class="tnk-card__body">
        <div class="tnk-padding">
          <div class="main-content">
            <div>
              <form [formGroup]="data.workPlaceForm">
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.compOrBuilding }"
                    >
                      <label class="control-label" for="acc_compOrBuilding">
                        Nama Gedung
                      </label>
                      <p>Contoh : grha niaga thamrin</p>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_compOrBuilding"
                        formControlName="compOrBuilding"
                      />
                      <small class="text-danger">
                        {{ data.errors.compOrBuilding }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.buildingNumber }"
                    >
                      <label class="control-label" for="acc_buildingNumber">
                        Nomor Gedung
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_buildingNumber"
                        formControlName="buildingNumber"
                      />
                      <small class="text-danger">
                        {{ data.errors.buildingNumber }}
                      </small>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-4">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.flatNumber }"
                    >
                      <label class="control-label" for="acc_flatNumber">
                        Nomor Blok/Kavling
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_flatNumber"
                        formControlName="flatNumber"
                      />
                      <small class="text-danger">
                        {{ data.errors.flatNumber }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.buildingType }"
                    >
                      <label class="control-label" for="acc_buildingType">
                        Jenis Bangunan
                      </label>
                      <select
                        id="acc_buildingType"
                        class="form-control"
                        id="acc_buildingType"
                        formControlName="buildingType"
                      >
                        <option [value]="0">Pilih Salah Satu</option>
                        <option
                          *ngFor="let building of data.buildingType"
                          [value]="building.value"
                        >
                          {{ building.name }}
                        </option>
                      </select>
                      <small class="text-danger">
                        {{ data.errors.buildingType }}
                      </small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.street }"
                    >
                      <label class="control-label" for="acc_street">
                        Nama Jalan
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_street"
                        formControlName="street"
                      />
                      <small class="text-danger">{{ data.errors.street }}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6 col-md-4">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.rt }"
                    >
                      <label class="control-label" for="acc_rt">RT</label>
                      <p>Jika tidak ada, isi 0 (nol)</p>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_rt"
                        formControlName="rt"
                        (keypress)="numericalInputOnly($event)"
                      />
                      <small class="text-danger">{{ data.errors.rt }}</small>
                    </div>
                  </div>
                  <div class="col-xs-6 col-md-4">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.rw }"
                    >
                      <label class="control-label" for="acc_rw">RW</label>
                      <p>Jika tidak ada, isi 0 (nol)</p>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_rw"
                        formControlName="rw"
                        (keypress)="numericalInputOnly($event)"
                      />
                      <small class="text-danger">{{ data.errors.rw }}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.province }"
                    >
                      <label class="control-label" for="acc_province">
                        Provinsi
                      </label>
                      <select
                        id="acc_province"
                        class="form-control"
                        id="acc_province"
                        formControlName="province"
                        (change)="
                          service.getRegions(
                            { province: $event.target.value },
                            'city',
                            null,
                            true
                          )
                        "
                      >
                        <option [value]="0" disabled hidden>
                          Pilih Salah Satu
                        </option>
                        <option
                          *ngFor="let province of data.provinces"
                          [value]="province.province"
                        >
                          {{ province.province }}
                        </option>
                      </select>
                      <small class="text-danger">{{ data.errors.province }}</small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.city }"
                      *ngIf="data.workPlaceForm.value.province !== '0'"
                    >
                      <label class="control-label" for="acc_city">Kota</label>
                      <select
                        id="acc_city"
                        class="form-control"
                        id="acc_city"
                        formControlName="city"
                        (change)="
                          service.getRegions(
                            { city: $event.target.value },
                            'district',
                            null,
                            true
                          )
                        "
                      >
                        <option [value]="0" disabled hidden>
                          Pilih Salah Satu
                        </option>
                        <option
                          *ngFor="let city of data.cities"
                          [value]="city.city"
                        >
                          {{ city.city }}
                        </option>
                      </select>
                      <small class="text-danger">{{ data.errors.city }}</small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.district }"
                      *ngIf="data.workPlaceForm.value.city !== '0'"
                    >
                      <label class="control-label" for="acc_district">
                        Kecamatan
                      </label>
                      <select
                        id="acc_district"
                        class="form-control"
                        id="acc_district"
                        formControlName="district"
                        (change)="
                          service.getRegions(
                            { district: $event.target.value },
                            'village',
                            null,
                            true
                          )
                        "
                      >
                        <option [value]="0" disabled hidden>
                          Pilih Salah Satu
                        </option>
                        <option
                          *ngFor="let district of data.districts"
                          [value]="district.district"
                        >
                          {{ district.district }}
                        </option>
                      </select>
                      <small class="text-danger">{{ data.errors.district }}</small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.village }"
                      *ngIf="data.workPlaceForm.value.district !== '0'"
                    >
                      <label class="control-label" for="acc_village">
                        Kelurahan
                      </label>
                      <select
                        id="acc_village"
                        class="form-control"
                        id="acc_village"
                        formControlName="village"
                        (change)="
                          service.getRegions(
                            { village: $event.target.value },
                            'postal_code',
                            null,
                            true
                          )
                        "
                      >
                        <option [value]="0" disabled hidden>
                          Pilih Salah Satu
                        </option>
                        <option
                          *ngFor="let village of data.villages"
                          [value]="village.village"
                        >
                          {{ village.village }}
                        </option>
                      </select>
                      <small class="text-danger">{{ data.errors.village }}</small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.postalCode }"
                      *ngIf="data.workPlaceForm.value.village !== '0'"
                    >
                      <label class="control-label" for="acc_postalCode">
                        Kode Pos
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_postalCode"
                        formControlName="postalCode"
                        [attr.disabled]="true"
                      />
                      <small class="text-danger">
                        {{ data.errors.postalCode }}
                      </small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.officePhoneNumber }"
                    >
                      <label class="control-label" for="acc_officePhoneNumber">
                        Nomor Telepon Tempat Kerja
                      </label>
                      <p>Contoh: 021123456</p>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_officePhoneNumber"
                        formControlName="officePhoneNumber"
                        (keypress)="numericalInputOnly($event)"
                      />
                      <small class="text-danger">
                        {{ data.errors.officePhoneNumber }}
                      </small>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div
                      class="form-group"
                      [ngClass]="{ 'has-error': data.errors.jobRole }"
                    >
                      <label class="control-label" for="acc_jobRole">
                        Jabatan Pekerjaan
                      </label>
                      <p>Contoh: Bagian Keuangan, Akuntan</p>
                      <input
                        type="text"
                        class="form-control"
                        id="acc_jobRole"
                        formControlName="jobRole"
                      />
                      <small class="text-danger">{{ data.errors.jobRole }}</small>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tnk-card__nav">
      <div class="tnk-padding">
        <div class="row">
          <div class="col-xs-6">
            <button
              class="tnk-button__green block"
              (click)="service.parentService.prevStep()"
            >
              Sebelumnya
            </button>
          </div>
          <div class="col-xs-6">
            <button
              (click)="service.parentService.nextStep()"
              [disabled]="!data.workPlaceForm.valid"
              [ngClass]="{ disabled: !data.workPlaceForm.valid }"
              class="tnk-button__green block active right"
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationWorkPlaceService, },
];
}

function ConfirmationWorkPlaceComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationWorkPlaceComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationWorkPlaceComponent.ctorParameters;
/** @type {?} */
ConfirmationWorkPlaceComponent.prototype.data;
/** @type {?} */
ConfirmationWorkPlaceComponent.prototype.numericalInputOnly;
/** @type {?} */
ConfirmationWorkPlaceComponent.prototype.service;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
